import { Directive, TemplateRef, ViewContainerRef, inject, effect, input } from '@angular/core';
import { AuthenticationService } from '@core/auth/authentication.service';

@Directive({
  selector: '[hasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  private authService = inject(AuthenticationService);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  readonly hasPermission = input<string>(''); // formato: "modulo:accion" ej: "laboratorio:create"

  constructor() {
    effect(() => {
      const [moduleCode, action] = this.hasPermission().split(':');

      if (!moduleCode || !action) {
        console.warn('hasPermission directive requires format "module:action"');
        return;
      }

      const hasAccess = this.authService.hasPermission(moduleCode, action);

      if (hasAccess) {
        if (this.viewContainer.length === 0) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
